/* Voci del menu del sito: apre i due pannelli larghi (mouse con un attimo di attesa, tocco, tastiera).
   Nient'altro: ricerca, carrello e account restano quelli del tema. */
(function () {
  'use strict';
  var puntatore = window.matchMedia('(hover: hover) and (pointer: fine)');
  var tApri = 0, tChiudi = 0;
  function voci() { return document.querySelectorAll('.cdn-nv .cdn-m2__item--sub'); }
  function chiudiTutte(tranne) {
    voci().forEach(function (v) {
      if (v === tranne) return;
      v.classList.remove('is-open');
      var b = v.querySelector('[aria-expanded]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function apri(v) {
    chiudiTutte(v);
    v.classList.add('is-open');
    var b = v.querySelector('[aria-expanded]');
    if (b) b.setAttribute('aria-expanded', 'true');
  }
  document.addEventListener('mouseover', function (e) {
    if (!puntatore.matches) return;
    var v = e.target.closest ? e.target.closest('.cdn-nv .cdn-m2__item--sub') : null;
    clearTimeout(tApri); clearTimeout(tChiudi);
    if (!v) {
      if (e.target.closest && e.target.closest('.cdn-nv, .cdn-m2__mega')) return;
      tChiudi = setTimeout(function () { chiudiTutte(); }, 180);
      return;
    }
    if (!v.classList.contains('is-open')) tApri = setTimeout(function () { apri(v); }, 90);
  });
  document.addEventListener('click', function (e) {
    var testa = e.target.closest ? e.target.closest('[data-cdn-nv-sub]') : null;
    if (testa) {
      var v = testa.closest('.cdn-m2__item--sub');
      var aperta = v.classList.contains('is-open');
      if (!aperta) { e.preventDefault(); apri(v); } else { chiudiTutte(); }
      return;
    }
    if (!e.target.closest('.cdn-m2__mega')) chiudiTutte();
  });
  document.addEventListener('focusin', function (e) {
    var v = e.target.closest ? e.target.closest('.cdn-nv .cdn-m2__item--sub') : null;
    if (v) apri(v); else if (!e.target.closest('.cdn-m2__mega')) chiudiTutte();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') chiudiTutte(); });

  /* Il tema decide UNA volta sola, al caricamento, se mostrare il menu disteso o il tasto menu:
     misura l'intestazione quando il carattere non è ancora arrivato, quindi la conta più larga del vero.
     Appena i caratteri sono pronti gli chiediamo di rifare il conto con i suoi stessi metodi. */
  function rimisura() {
    var el = document.querySelector('.header__wrapper');
    if (!el || typeof el.getMinWidth !== 'function' || typeof el.checkWidth !== 'function') return;
    try { el.minWidth = el.getMinWidth(); el.checkWidth(); } catch (e) {}
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(rimisura, 60); });
  window.addEventListener('load', function () { setTimeout(rimisura, 200); });
})();
